import React from 'react';
import { useTranslation } from 'react-i18next';
import { Warning } from '@material-ui/icons';
import './ActionsInfo.scss';

function refreshPage() {
  window.location.reload(true);
}

export const ActionsInfoHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="actions-info">
      <Warning className="icon" fontSize="small" />
      <div className="message">{t('assessment.simultaneousEdit.ddeActionsTriggered')}</div>
      <div className="link" onClick={refreshPage}>
        {t('assessment.simultaneousEdit.refresh')}
      </div>
    </div>
  );
};

export default ActionsInfoHeader;
